// extracted by mini-css-extract-plugin
export default {"doctorsDiv":"DoctorCardNoButton_doctorsDiv__yBRRs","doctorImg":"DoctorCardNoButton_doctorImg__+RUQk","information":"DoctorCardNoButton_information__ZvL0Y"};